/**
* Practice Areas JS
* -----------------------------------------------------------------------------
*
* All the JS for the Practice Areas component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {

    className: 'practice-areas',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( document ).on( 'click', '.practice-area-button', function() {
        const $card = $( this ).closest( '.practice-area-card' );
        $card.find( '.practice-area-content' ).toggleClass( 'visible' );
        $card.find( '.title-container' ).toggleClass( 'visible' );
      } );

      // Mobile-only Splide, jQuery .each style
      if ( $( '.practice-areas-slider.splide' ).length ) {
        $( '.practice-areas-slider.splide' ).each( function( index, element ) {
          const mql = window.matchMedia( '(max-width: 1023px)' );
          let splide = null;

          function mount() {
            if ( splide ) return;
            splide = new Splide( element, {
              type: 'loop',
              perPage: 1,
              perMove: 1,
              gap: '1rem',
              arrows: true, // uses your .splide__arrow--prev/--next inside this .splide
              pagination: false, // no dots
              drag: true,
              speed: 500,
              // autoHeight: true, // uncomment if slide heights vary a lot
            } );
            splide.on( 'destroy', function() {
              splide = null;
            } );
            splide.mount();
          }

          function destroy() {
            if ( !splide ) return;
            splide.destroy( true );
            splide = null;
          }

          function onChange( e ) {
            if ( e.matches ) mount();
            else destroy();
          }

          // initial + responsive
          onChange( mql );
          mql.addEventListener( 'change', onChange );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'practice-areas', COMPONENT );
} )( app );
